<template>
    <button :class="'ap-sw-btn btn-' + type" v-bind="$attrs">
        <slot />
    </button>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        cssClass: String,
        type: String
    },
}
</script>

<style lang="scss">
    @import '~styles/colors';

    .ap-sw-btn {
        cursor: pointer;
        width: 100%;
        height: 30px;
        border-radius: 3px;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        text-align: center;

        &.btn-submit {
            background-color: $btn-submit-bg-color;
            border: none;
            color: $btn-submit-color;

            &:hover:not(:disabled) {
                background-color: $btn-submit-hover-bg-color;
            }

            &:disabled {
                background-color: $btn-submit-disabled-bg-color;
                cursor: text;
            }
        }

        &.btn-panel {
            background-color: $btn-panel-bg-color;
            color: $btn-panel-color;
            border: solid 1px $btn-panel-border-color;

            &:hover:not(:disabled) {
                border-color: $btn-panel-hover-border-color;
                color: $btn-panel-hover-bg-color;
            }

            &:disabled {
                opacity: 0.5;
                cursor: text;
            }
        }
    }
</style>